import { Button, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { SYSTEM_USER_NAME } from "../../../../../Todos/Todos.constants";
import { useVollmachtMsbFiles } from "../hooks/useVollmachtMsbFiles";
import { useVollmachtVermarkterFiles } from "../hooks/useVollmachtVermarkterFiles";
import { getLatestDocuments } from "../utils/getLatestDocuments";
import { UserDocumentsModal } from "./UserDocumentsModal";

type UserDocumentsProps = {
  siteId: number;
};

function UserDocuments({ siteId }: UserDocumentsProps) {
  const { data: msbFiles } = useVollmachtMsbFiles(siteId);
  const { data: vermarkterFiles } = useVollmachtVermarkterFiles(siteId);

  const msbDocuments = getLatestDocuments({
    documents: msbFiles?.todoFiles.filter(
      (file) => file.createdBy?.name !== SYSTEM_USER_NAME
    )
  });

  const vermarkterDocuments = getLatestDocuments({
    documents: vermarkterFiles?.todoFiles.filter(
      (file) => file.createdBy?.name !== SYSTEM_USER_NAME
    )
  });

  const totalDocumentsCount = msbDocuments.length + vermarkterDocuments.length;

  const [opened, { open, close }] = useDisclosure(false);
  if (totalDocumentsCount === 0) {
    return null;
  }

  return (
    <>
      <Button mt="xs" variant="outline" w="100%" onClick={open}>
        Alle Vollmachten ansehen
      </Button>
      <Modal opened={opened} size="xl" title="Ihre Vollmachten" onClose={close}>
        <UserDocumentsModal
          msbDocuments={msbDocuments}
          vermarkterDocuments={vermarkterDocuments}
        />
      </Modal>
    </>
  );
}

export { UserDocuments };
